import React from "react";
import { displayAccountLabel } from "@common/helpers/accounting";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import {
    useWorkspaceAccounts,
    useWorkspaceAccrualAccounts,
} from "@api/account.api";
import { findFirstResolvingAccount } from "@components/accounts/resolveAccountsForIds";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    // One uuid per covered business; the label shows the first uuid that
    // resolves in the workspace accounts list (same vanish-on-miss as before
    // when none resolve).
    values: string[];
    label?: string;
    isAccrual?: boolean;
}

export const RuleAccountAction: React.FC<Props> = ({
    values,
    label = "Assign cash ledger",
    isAccrual = false,
}) => {
    const cashAccounts = useWorkspaceAccounts();
    const accrualAccounts = useWorkspaceAccrualAccounts();
    const accounts = isAccrual ? accrualAccounts.data : cashAccounts.data;
    const showAccountNumbers = useShowAccountNumbers();

    const account = findFirstResolvingAccount(values, accounts);

    if (!account) {
        return null;
    }

    return (
        <RuleTagRow
            label={label}
            type="action"
            values={[displayAccountLabel(account, showAccountNumbers)]}
        />
    );
};
